var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 13.3636V19C17 20.1046 16.1046 21 15 21H3C1.89543 21 1 20.1046 1 19V11C1 9.89543 1.89543 9 3 9H5",
    stroke: "#FB7C51",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19.0001C22.6569 19.0001 24 17.657 24 16.0001C24 14.3433 22.6569 13.0001 21 13.0001C19.3431 13.0001 18 14.3433 18 16.0001C18 17.657 19.3431 19.0001 21 19.0001Z",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.0001C10.6569 12.0001 12 10.657 12 9.00012C12 7.34327 10.6569 6.00012 9 6.00012C7.34315 6.00012 6 7.34327 6 9.00012C6 10.657 7.34315 12.0001 9 12.0001Z",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5898 10.5101L18.4198 14.4901",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0849 4.87986C19.1563 4.87986 20.0249 4.01132 20.0249 2.93993C20.0249 1.86854 19.1563 1 18.0849 1C17.0136 1 16.145 1.86854 16.145 2.93993C16.145 4.01132 17.0136 4.87986 18.0849 4.87986Z",
    stroke: "#FB7C51",
    strokeWidth: 1.29329,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4101 3.91638L12 6.49002",
    stroke: "#FB7C51",
    strokeWidth: 1.29329,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepoIcon);
export default __webpack_public_path__ + "static/media/repoIcon.5c3589693840ae07288922bf8f8e486b.svg";
export { ForwardRef as ReactComponent };